import type { RouteRecordRaw } from 'vue-router'
const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
      noCheck: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
      noCheck: true,
    },
  },
  {
    path: '/:path(.*)',
    name: '404',
    component: () => import('@/views/error/404.vue'),
    meta: {
      noHistory: true,
      noCheck: true,
    },
  },
  {
    path: '/redirect/:path(.*)',
    name: 'redirect',
    component: () => import('@/views/redirect/index.vue'),
    meta: {
      noCheck: true,
    },
  },
]
export default constantRoutes
